import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';

export const useAdminRetrieveBatchLRNs = (batchCounter: number) => {
  return useQuery({
    queryKey: ['admin-retrieve-batch-lrns', batchCounter],
    queryFn: async (): Promise<string[]> => {
      const response = await request({
        path: `admin/retrieve-batch-lrns/${batchCounter}`,
        method: 'GET',
        authenticate: true,
      });

      toast.success('Batch LRNs retrieved successfully!');
      return response.data;
    },
    enabled: false,
    retry: false,
  });
};
